"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateChatsProvider = void 0;
const ChatsProvider_1 = require("./ChatsProvider");
const PrivateChatsContext_1 = require("./PrivateChatsContext");
exports.PrivateChatsProvider = (0, ChatsProvider_1.createChatProvider)(PrivateChatsContext_1.PrivateChatsContext, {
    getChatManager: selectedOrgUser => selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getPrivateChatManager(),
});
